// plugins/userway.client.ts
export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig()

    if (process.client && config.public.userwayAccount) {
        nuxtApp.hook('app:mounted', () => {
            const script = document.createElement('script')
            script.setAttribute('data-account', config.public.userwayAccount)
            script.setAttribute('src', 'https://cdn.userway.org/widget.js')
            script.setAttribute('crossorigin', 'anonymous')

            // Add noscript message
            const noscript = document.createElement('noscript')
            noscript.innerHTML = 'Please ensure Javascript is enabled for purposes of <a href="https://userway.org">website accessibility</a>'

            document.body.appendChild(script)
            document.body.appendChild(noscript)
        })
    }
})